import { Box } from '@mui/material'
import { PieChart } from '@mui/x-charts/PieChart'
import { RosterProfileQuery } from '__generated__/graphql'
import { FC } from 'react'
import { useProcessStatusColorMap } from 'recruiter/components/ProcessStatusPill/colorHelperFunction'

interface DonutGraphProps {
    data: RosterProfileQuery['roster']
}

interface ChartDataItem {
    label: string
    value: number
    id?: string
}

const RosterHeaderDonutGraph: FC<DonutGraphProps> = ({ data }) => {
    const candidateProcessStatusSummary =
        data?.candidateProcessStatusGroupSummary || []

    const chartData: ChartDataItem[] = candidateProcessStatusSummary.map(
        (item) => ({
            label: item.statusSummaryGroup?.label,
            value: item.count,
        })
    )

    const labels = candidateProcessStatusSummary.map(
        (item) => item.statusSummaryGroup.summaryGroup
    )
    const colorMatch = useProcessStatusColorMap(labels)

    return (
        <Box sx={{ flexGrow: 1 }}>
            <PieChart
                height={270}
                colors={Array.isArray(colorMatch) ? colorMatch : [colorMatch]}
                width={300}
                margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                slotProps={{
                    legend: { hidden: true },
                }}
                series={[
                    {
                        innerRadius: 50,
                        cornerRadius: 0,
                        outerRadius: 100,
                        data: chartData,
                        highlightScope: { fade: 'global', highlight: 'item' },
                        faded: {
                            innerRadius: 30,
                            additionalRadius: -30,
                            color: 'gray',
                        },
                    },
                ]}
            />
        </Box>
    )
}

export default RosterHeaderDonutGraph
